import axios from 'axios';
import { getAppPath } from '../config/appPath';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const grandEstApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/ticketing-portal/grand-est-2026',
});

grandEstApi.interceptors.response.use((config) => {
  if (config.status === 401) {
    window.location.href = getAppPath('/login');
  }
  return config;
});

const ADMIN_DEFAULT_MASTER_ORGANIZATION = '650bd89479ba3ae92524955b';

export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/ticketing-portal/grand-est-2026/admin',
});

// Add request interceptor to include masterOrganization in every request
adminApi.interceptors.request.use((config) => {
  config.params = config.params || {};
  // Only set masterOrganization if not already provided
  if (!config.params.masterOrganization) {
    config.params.masterOrganization = ADMIN_DEFAULT_MASTER_ORGANIZATION;
  }
  return config;
});

adminApi.interceptors.response.use((config) => {
  if (config.status === 401) {
    window.location.href = getAppPath('/admin/login');
  }
  return config;
});

export const fetchTranslations = () => {
  return api.get('/public/translations/grand-est-ticketing-portal-twenty-six');
};

export const getWSFRegionalInformation = async (params) => {
  const url =
    `https://data.education.gouv.fr/api/explore/v2.1/catalog/datasets/fr-en-annuaire-education/records?` +
    new URLSearchParams({ limit: 20, ...params });
  const response = await fetch(url, {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};

export const getBookedTimeSlots = async (masterOrganization = '650bd89479ba3ae92524955b') => {
  return grandEstApi.get('/booked-time-slots', {
    params: {
      masterOrganization,
    },
  });
};

export const schoolRegistration = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return grandEstApi.post('/school-registration', {
    ...body,
    masterOrganization,
  });
};

export const otherGroupsRegistration = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return grandEstApi.post('/other-groups-registration', {
    ...body,
    masterOrganization,
  });
};

export const login = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/grandest2026', {
    ...body,
    masterOrganization,
  });
};

export const validateMagic = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/grandest2026-magic', {
    ...body,
    masterOrganization,
  });
};

export const getDashboardDetails = () => {
  return grandEstApi.get('/me');
};

export const updateDashboardDetails = (body) => {
  return grandEstApi.put('/me', body);
};

export const adminLogin = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/grandest2026/admin', {
    ...body,
    masterOrganization,
  });
};

export const validateAdminMagic = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/grandest2026/admin-magic', {
    ...body,
    masterOrganization,
  });
};

export const getRegistrationStats = () => {
  return adminApi.get('/registration-stats');
};

export const getDateRegistrationStats = (registrationType = null) => {
  const params = {};
  if (registrationType && registrationType !== 'all') {
    params.registrationType = registrationType;
  }
  return adminApi.get('/date-registration-stats', { params });
};

export const getHourlyTimeSlotStats = (registrationType = null) => {
  const params = {};
  if (registrationType && registrationType !== 'all') {
    params.registrationType = registrationType;
  }
  return adminApi.get('/hourly-time-slot-stats', { params });
};

export const getRegistrationsList = (
  registrationType = 'all',
  type = 'all',
  page = 1,
  limit = 10,
) => {
  return adminApi.get('/registrations-list', {
    params: {
      registrationType,
      type,
      page,
      limit,
    },
  });
};

export const getRegistrationDetails = (id) => {
  return adminApi.get(`/registration-details/${id}`);
};

export const updateRegistrationDetails = (id, body) => {
  return adminApi.put(`/registration-details/${id}`, body);
};

export const deleteRegistration = (id, emailData) => {
  return adminApi.delete(`/registration-details/${id}`, {
    data: emailData,
  });
};

export const exportData = (exportOptions, signal) => {
  return adminApi.post(
    '/export-data',
    {
      ...exportOptions,
    },
    {
      signal,
    },
  );
};

export const sendEmailMessage = (emailOptions, signal) => {
  return adminApi.post(
    '/send-email-message',
    {
      ...emailOptions,
    },
    {
      signal,
    },
  );
};

export const getSlotReservationStats = (type) => {
  return adminApi.get(`/slots-reservation-stats/${type}`);
};
